import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NotFoundWrapper = styled.div`
  padding: 1em 1.5em;
`;

const NotFound = () => (
  <NotFoundWrapper>
    <h1>Not Found.</h1>
    <p>Go <Link to="/">home</Link> maybe?</p>
  </NotFoundWrapper>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.jsx